import { createDefaultNativeStackNavigator } from 'app/lib/navigation';
import { ForgotPasswordScreen } from 'app/screens/password-recovery/forgot-password';
import { ResetPasswordScreen } from 'app/screens/password-recovery/reset-password';

export type Parameters = {
  'forgot-password': undefined;
  'reset-password': { email: string; code?: string };
};

export { linking } from './navigator.linking';

const Stack = createDefaultNativeStackNavigator<Parameters>({
  withChat: false,
  withInvite: false,
});

export function Navigator() {
  return (
    <Stack.Navigator initialRouteName="forgot-password">
      <Stack.Screen component={ForgotPasswordScreen} name="forgot-password" />
      <Stack.Screen component={ResetPasswordScreen} name="reset-password" />
    </Stack.Navigator>
  );
}
